exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CategoryPage-module__main__AOepp {\r\n    width: 100%;\r\n}\r\n\r\n.CategoryPage-module__container__category_name__3qJ14 {\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n    text-align: center;\r\n}\r\n\r\n.CategoryPage-module__hidden__1CjuJ {\r\n    display: none;\r\n}", ""]);

// exports
exports.locals = {
	"main": "CategoryPage-module__main__AOepp",
	"container__category_name": "CategoryPage-module__container__category_name__3qJ14",
	"hidden": "CategoryPage-module__hidden__1CjuJ"
};